import { WaterPercentAlertIcon } from './WaterPercentAlertIcon';

/**
 * author: Colton Wiscombe
 * id 55C44783-89D5-4A31-86B8-863B719EC876
 * name water-percent-alert
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/water-percent-alert.svg
 * tags
 * - Alert / Error 
 * - Nature 
 */
export const HumidityAlertIcon = WaterPercentAlertIcon;
export default HumidityAlertIcon